import styled from 'styled-components';

export const Page = styled.div`
  padding: 5px;
  height: 110vh;
  text-align: center;
  button {
    margin-top: 18px !important;
    margin: auto;
  }
  #CardStatus {
    margin: auto;
    margin-top: 20px;
  }
`;

export const Imagem = styled.img`
  padding: 30px;
  padding-bottom: 130px;
  margin: auto;
  width: 100vh;
`;

export const Titulo = styled.h1`
  font-size: 50pt;
  font-weight: 600;
  color: var(--primary-color-sefaz);
  margin-bottom: 0;
`;

export const Subtitulo = styled.p`
  font-size: 25pt;
  font-weight: 500;
  padding: 0 0 10px 0;
  color: var(--primary-color-sefaz);
  margin-bottom: 0;
  margin-top: -21px;
`;

export const Descricao = styled.p`
  width: 50%;
  margin: auto;
  padding: 5px;
  padding-top: 0px;
  font-weight: ${props => props.fontWeight};
  @media (max-width: 1840px) {
    width: 90%;
  }
`;
